import { render, staticRenderFns } from "./text-compare-suggestion.vue?vue&type=template&id=5f00f44c&scoped=true"
import script from "./text-compare-suggestion.vue?vue&type=script&lang=js"
export * from "./text-compare-suggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00f44c",
  null
  
)

export default component.exports